// extracted by mini-css-extract-plugin
module.exports = {"flexblocks":"NurseryStyles_flexblocks__0c2KA","copyBlock":"NurseryStyles_copyBlock__JFuMF"};